import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { Caja } from '../caja';
import { cajaDetalle } from '../cajaDetalle';
import { CajaService } from '../caja.service';
import { AlertService } from 'ngx-alerts';

@Component({
  selector: 'app-caja',
  templateUrl: './caja.component.html',
  styleUrls: ['./caja.component.css']
})
export class CajaComponent implements OnInit {

  un_centavo: number;
  total_centavos: number
  cinco_centavo: number;
  diez_centavo: number;
  veinticion_centavo: number;
  cincuenta_centavo: number;
  un_dolar: number;
  billete_uno: number;
  billete_cinco: number;
  billete_diez: number;
  billete_veinte: number;
  billete_cincuenta: number;
  billete_cien: number;
  total_caja: number;
  total_billete_uno: number;
  total_billete_cinco: number;
  total_billete_diez: number;
  total_billete_veinte: number;
  total_billete_cincuenta: number;
  total_billete_cien: number;
  total_tarjeta: number;
  caja: Caja;
  cajaDetalle: cajaDetalle;
  total_un_dolar: number;
  total_veinticion_centavo: number;
  total_cincuenta_centavo: number;
  total_diez_centavo: number;
  total_cinco_centavo: number;
  total_centavos_centavos: number
  veiniticion_centavo: number;
  cajas: Caja[]= [];
  moneda_un_dolar: number;
  previous: any = [];
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;

  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;

  @ViewChild('modalCaja') public modalCaja: ModalDirective;


  constructor(private cdRef: ChangeDetectorRef, private alertService: AlertService, private modalService: NgbModal, private api: CajaService) { }

  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(5);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }


  ngOnInit(): void {
    this.un_centavo = 0;
    this.cinco_centavo = 0;
    this.diez_centavo = 0;
    this.veinticion_centavo = 0;
    this.un_dolar = 0;
    this.cincuenta_centavo = 0;
    this.billete_uno = 0
    this.billete_cinco = 0
    this.billete_diez = 0;
    this.billete_veinte = 0;
    this.billete_cincuenta = 0;
    this.billete_cien = 0;

    this.total_tarjeta = 0;
    this.total_centavos = 0;
    this.total_cinco_centavo = 0;
    this.total_diez_centavo = 0;
    this.total_veinticion_centavo = 0;
    this.total_un_dolar = 0;
    this.total_cincuenta_centavo = 0;
 
    this.total_billete_uno = 0
    this.total_billete_cinco = 0
    this.total_billete_diez = 0;
    this.total_billete_veinte = 0;
    this.total_billete_cincuenta = 0;
    this.total_billete_cien = 0;
    this.listarCaja();
  }

  limpiar() {
    this.un_centavo = 0;
    this.cinco_centavo = 0;
    this.diez_centavo = 0;
    this.veinticion_centavo = 0;
    this.un_dolar = 0;
    this.cincuenta_centavo = 0;
    this.billete_uno = 0
    this.billete_cinco = 0
    this.billete_diez = 0;
    this.billete_veinte = 0;
    this.billete_cincuenta = 0;
    this.billete_cien = 0;

    this.total_tarjeta = 0;
    this.total_centavos = 0;
    this.total_cinco_centavo = 0;
    this.total_diez_centavo = 0;
    this.total_veinticion_centavo = 0;
    this.total_un_dolar = 0;
    this.total_cincuenta_centavo = 0;


    this.total_billete_uno = 0
    this.total_billete_cinco = 0
    this.total_billete_diez = 0;
    this.total_billete_veinte = 0;
    this.total_billete_cincuenta = 0;
    this.total_billete_cien = 0;

  }

  valorTotalBilleteVeinte() {
    this.total_billete_veinte = 20 * this.billete_veinte;
    this.total_billete_veinte = this.redondear(this.total_billete_veinte);
  }

  valorTotalBilleteCincuenta() {
    this.total_billete_cincuenta = 50 * this.billete_cincuenta;
    this.total_billete_cincuenta = this.redondear(this.total_billete_cincuenta);
  }


  valorTotalBilleteCien() {
    this.total_billete_cien = 100 * this.billete_cien;
    this.total_billete_cien = this.redondear(this.total_billete_cien);
  }

  valorTotalBilleteCinco() {
    this.total_billete_cinco = 5 * this.billete_cinco;
    this.total_billete_cinco = this.redondear(this.total_billete_cinco);
  }

  valorTotalBilleteDiez() {
    this.total_billete_diez = 10 * this.billete_diez;
    this.total_billete_diez = this.redondear(this.total_billete_diez);
  }

  valorTotalBilleteUno() {
    this.total_billete_uno = 1 * this.billete_uno;
    this.total_billete_uno = this.redondear(this.total_billete_uno);
  }
  valorTotalMonedaUnDolar() {
    this.total_un_dolar = 1 * this.un_dolar;
    this.total_un_dolar = this.redondear(this.total_un_dolar);
  }


  valorTotalMonedaCincuenta() {
    this.total_cincuenta_centavo = 0.50 * this.cincuenta_centavo;
    this.total_cincuenta_centavo = this.redondear(this.total_cincuenta_centavo);
  }
  valorTotalMonedaCinco() {
    this.total_cinco_centavo = 0.05 * this.cinco_centavo;
    this.total_cinco_centavo = this.redondear(this.total_cinco_centavo);
  }
  valorTotalCentavos() {
    this.total_centavos = 0.01 * this.un_centavo;
    this.total_centavos = this.redondear(this.total_centavos);
  }
  valorTotalDiez() {
    this.total_diez_centavo = 0.10 * this.diez_centavo;
    this.total_diez_centavo = this.redondear(this.total_diez_centavo);
  }

  valorTotalVeinticinco() {
    this.total_veinticion_centavo = 0.25 * this.veinticion_centavo;
    this.total_veinticion_centavo = this.redondear(this.total_veinticion_centavo);
  }
  redondear(numero: number) {
    this.totalEfectivoCaja();
    return Math.round((numero + Number.EPSILON) * 100) / 100;
  }
  redondearTotal(numero: number) {
    return Math.round((numero + Number.EPSILON) * 100) / 100;
  }

  ver(caja:Caja,content){
    this.un_centavo = caja.detalle.moneda_centavo
    this.cinco_centavo = caja.detalle.modela5
    this.diez_centavo = caja.detalle.moneda10
    this.veinticion_centavo = caja.detalle.moneda25
    this.un_dolar = caja.detalle.modedaUno
    this.cincuenta_centavo = caja.detalle.moneda50
    this.billete_uno = caja.detalle.valorUnDolar
    this.billete_cinco = caja.detalle.valorDolar5
    this.billete_diez = caja.detalle.valorDolar10
    this.billete_veinte = caja.detalle.valorDolar20
    this.billete_cincuenta = caja.detalle.valorDolar50
    this.billete_cien= caja.detalle.valorDolar100
    this.valorTotalBilleteCien();
    this.valorTotalBilleteCinco();
    this.valorTotalBilleteCincuenta();
    this.valorTotalBilleteDiez();
    this.valorTotalBilleteUno();
    this.valorTotalBilleteVeinte();
    this.valorTotalCentavos();
    this.valorTotalMonedaUnDolar();
    this.valorTotalMonedaCincuenta();
    this.valorTotalVeinticinco();
    this.valorTotalDiez();

    this.modalService.open(content, { size: 'lg' })

  }

  listarCaja() {

    this.api.listaCaja(localStorage.getItem('id'), localStorage.getItem('usuario'))
      .subscribe((
        data: Caja[]) => {
        this.cajas = data;
        this.mdbTable.setDataSource(this.cajas);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      }
        , err => {
          console.log(err);
        });
  }
  eliminar(id){
  this.api.eliminar(id).subscribe(

    data  => {
      this.alertService.success("Se elimino con exito..");
      this.listarCaja();
    
    },
    
    error  => {
    this.alertService.danger("No se puede eliminar..");

    
    }
    
    );
  }


  guardar() {
    this.caja = new Caja()
    this.caja.caja = Number.parseInt(localStorage.getItem("caja"))
    this.caja.total = this.total_caja;
    this.caja.id = 0;
    this.caja.usuario = localStorage.getItem('usuario')
    this.caja.tarjeta = 0;
    this.caja.transferencia = 0;
    this.caja.idEmisor = Number.parseInt(localStorage.getItem('id'))
    this.caja.estado = "A"
    this.caja.detalle = new cajaDetalle()
    this.caja.detalle.id = 0
    this.caja.detalle.modedaUno = this.billete_uno
    this.caja.detalle.modela5 = this.cinco_centavo
    this.caja.detalle.moneda10 = this.diez_centavo
    this.caja.detalle.moneda25 = this.veinticion_centavo
    this.caja.detalle.moneda50 = this.cincuenta_centavo
    this.caja.detalle.moneda_centavo = this.un_centavo
    this.caja.detalle.valorUnDolar = this.billete_uno
    this.caja.detalle.valorDolar5 = this.billete_cinco
    this.caja.detalle.valorDolar10 = this.billete_diez
    this.caja.detalle.valorDolar20 = this.billete_veinte
    this.caja.detalle.valorDolar50 = this.billete_cincuenta
    this.caja.detalle.valorDolar100 = this.billete_cien

    this.api.aperturaCaja(this.caja).subscribe(

      data => {
        this.alertService.success("Se actualizo con exito..");
        this.listarCaja();
        this.modalCaja.close
      },

      error => {
        this.alertService.danger("Caja ya apeturada")
        this.alertService.danger(error)

      }

    );


  }

  totalEfectivoCaja() {
    this.total_caja = this.total_centavos + this.total_cinco_centavo +
      this.total_diez_centavo + this.total_veinticion_centavo + this.total_cincuenta_centavo
      + this.total_un_dolar + this.total_billete_uno + this.total_billete_cinco + this.total_billete_diez + this.total_billete_veinte
      + this.total_billete_cincuenta + this.total_billete_cien;
      this.total_caja = this.redondearTotal(this.total_caja)
    }

  agregarCaja(content) {
    this.limpiar();
    this.totalEfectivoCaja();
    this.modalService.open(content, { size: 'lg' })
  }

}
